// extracted by mini-css-extract-plugin
export default {"subscription_item_price":"nv","delete_item":"ov","subscription_item":"pv","subscription_item_img_wrapper":"qv","subscription_item_info":"rv","subscription_item_title":"sv","subscription_item_edit":"tv","subscription_item_wrapper":"uv","arrow":"vv","subscription_item_category":"wv","plus_button":"xv","more_details":"yv","old_price":"zv","discount":"Av"};
    if(module.hot) {
      // 1713361650053
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  